// extracted by mini-css-extract-plugin
export var deleteModal = "_eh-0";